module.exports = __webpack_public_path__ + "static/media/Logo-color.8b28d263.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo-color.svg
// module id = 102
// module chunks = 0